var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeeds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 15,
    fill: "url(#paint0_linear_9_160)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6105 27.3707L24.3471 38.3129C24.3471 38.3129 23.8975 39.0024 23.2078 39.0024C21.0194 39.0024 22.5184 36.3044 22.0987 37.2935L25.936 27.6403H21.2292C20.5397 27.6403 20 27.1008 20 26.4112C20 25.9314 20.1798 25.7217 20.1798 25.7217L29.833 14.6595C30.1028 14.2999 30.4325 14 30.9122 14C31.6017 14 32.1414 14.5395 32.1414 15.2292C32.1414 15.4989 31.362 17.4477 31.362 17.5075L28.484 25.272H32.7708C33.4603 25.272 34 25.8115 34 26.5012C33.9402 26.8013 33.7903 27.1612 33.6104 27.3709L33.6105 27.3707Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_160",
    x1: 40,
    y1: 47,
    x2: -19,
    y2: -37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E656AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB94C8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeeds);
export default __webpack_public_path__ + "static/media/speeds.bd350307dc829d3eebc03d0b56f316a9.svg";
export { ForwardRef as ReactComponent };